import { render, staticRenderFns } from "./DispensationCheckTab.vue?vue&type=template&id=2a701878&scoped=true&"
import script from "./DispensationCheckTab.vue?vue&type=script&lang=ts&"
export * from "./DispensationCheckTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a701878",
  null
  
)

export default component.exports